/** The guided setup of an authenticator app (ADR 0039). */
export const SETUP_AUTHENTICATOR_PATH = "/setup-authenticator";
